<template>
  <el-dialog
    :title="$t('pages.equipment.text60')"
    width="750px"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div>
      <el-dialog
        width="500px"
        :title="$t('public.text6')"
        :visible.sync="innerVisible"
        append-to-body
      >
        <div>
          {{ $t("pages.equipment.text68") }}{{ errorCount
          }}{{ $t("pages.equipment.text67") }}
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeErr">{{ $t("button.close") }}</el-button>
          <el-button type="primary" @click="downloadErr">{{
            $t("omission.text52")
          }}</el-button>
        </span>
      </el-dialog>
      <el-form ref="form" :rules="rules" :model="from" label-width="auto">
        <el-form-item :label="$t('button.downloadTemplate')">
          <DiluButton
            type="export"
            @click="importTemplate"
            :title="$t('button.downloadTemplate')"
          ></DiluButton>
          <span>{{ $t("pages.equipment.text61") }}</span>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text63')">
          <DiluButton
            type="import"
            @click="equipmentImport"
            :title="$t('pages.equipment.text63')"
            :fileList="fileList"
          ></DiluButton>
          <span>{{ $t("pages.equipment.text62") }}</span>
        </el-form-item>
        <el-form-item
          :label="$t('pages.equipment.text5')"
          prop="belongCategoryId"
        >
          <el-select
            v-model="from.belongCategoryId"
            clearable
            :placeholder="$t('public.text5')"
            @change="changeBelongCategoryId"
          >
            <el-option
              v-for="(item, index) in belongCategoryList"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('pages.equipment.text6')"
          v-if="from.belongCategoryId"
          prop="belongBikeTypeId"
        >
          <el-select
            v-model="from.belongBikeTypeId"
            clearable
            :placeholder="$t('public.text5')"
          >
            <el-option
              v-for="(item, index) in belongBikeTypeList"
              :key="index"
              :label="item.bikeTypeName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="导入批次号"
          v-if="from.belongBikeTypeId"
          prop="batchId"
        >
          <el-input
            class="batchIdLenth"
            v-model="from.batchId"
            placeholder="请输入批次号"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t("button.cancel") }}</el-button>
      <el-button type="primary" :loading="loading" @click="submitForm">{{
        $t("button.determine")
      }}</el-button>
    </span>
  </el-dialog>
</template>


<script>
import DiluButton from "../../../../components/pubilc/dilu-button.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      innerVisible: false,
      loading: false,
      from: {
        belongBikeTypeId: "", //车辆型号id
        belongCategoryId: "", //车辆类别id
        url: "", //	excel上的
        batchId: "",
        region: "",
      },
      errorCount: 0,
      fileList: [],
      belongBikeTypeList: [],
      setTime: null,
      code: "",
      rules: {
        batchId: [
          { required: true, message: "请输入批次ID", trigger: "blur" },
          {
            min: 6,
            max: 12,
            message: "长度在 6 到 12 个字符",
            trigger: "blur",
          },
        ],
        belongCategoryId: [
          { required: true, message: "请选择车辆类别", trigger: "change" },
        ],
        belongBikeTypeId: [
          { required: true, message: "请选择车辆型号", trigger: "change" },
        ],
      },
    };
  },
  components: {
    DiluButton,
  },
  computed: {
    ...mapState(["platformData"]),
  },
  props: ["dialogVisible", "belongCategoryList"],
  methods: {
    //关闭错误提示
    closeErr() {
      this.innerVisible = false;
      this.$emit("equipmentList");
      this.handleClose();
    },
    //下载错误报告
    downloadErr() {
      this.request.getFailInfo({ key: this.code }).then(() => {});
      this.innerVisible = false;
      this.$emit("equipmentList");
      this.handleClose();
    },
    //车辆型号-查询所有
    equipmentModeListAll(e) {
      this.request.findAllBikeTypeName("?bikeCategoryId=" + e).then((res) => {
        this.belongBikeTypeList = res.data;
      });
    },
    changeBelongCategoryId(e) {
      this.from.belongBikeTypeId = "";
      this.equipmentModeListAll(e);
    },
    //取消
    handleClose() {
      this.from = {
        belongBikeTypeId: "", //车辆型号id
        belongCategoryId: "", //车辆类别id
        url: "", //	excel上的
      };
      this.fileList = [];
      this.$emit("dialogClose");
      this.$refs["form"].resetFields();
    },
    //确定
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let that = this;
          this.from.region = this.platformData.region;
          if (!this.from.url) {
            return this.$message.error(this.$t("pages.equipment.text63"));
          }
          if (!this.from.belongCategoryId) {
            return this.$message.error(this.$t("pages.equipment.text64"));
          }
          if (!this.from.belongBikeTypeId) {
            return this.$message.error(this.$t("pages.equipment.text65"));
          }
          this.loading = true;
          this.request
            .equipmentListAdd(this.from)
            .then((res) => {
              that.setTime = setInterval(() => {
                that.request.equipmentListGetAddInfo(res.data).then((data) => {
                  this.code = res.data;
                  if (data.data.isCompleted) {
                    that.loading = false;
                    let str = `${that.$t("pages.equipment.text66")}${
                      data.data.successCount
                    } ${that.$t("pages.equipment.text67")},${that.$t(
                      "pages.equipment.text68"
                    )}${data.data.errorCount} ${that.$t(
                      "pages.equipment.text67"
                    )},${that.$t("omission.text24")}`;
                    that.$message.success(str);
                    this.errorCount = data.data.errorCount;
                    clearInterval(that.setTime);
                    that.setTime = null;
                    if (data.data.hasFailInfo) {
                      this.innerVisible = true;
                    } else {
                      that.$emit("equipmentList");
                      that.handleClose();
                    }
                  } else {
                    let str = `${that.$t("pages.equipment.text66")}${
                      data.data.successCount
                    } ${that.$t("pages.equipment.text67")},${that.$t(
                      "pages.equipment.text68"
                    )}${data.data.errorCount} ${that.$t(
                      "pages.equipment.text67"
                    )},${that.$t("omission.text23")}`;
                    that.$message.success(str);
                  }
                });
              }, 5000);
            })
            .catch(() => {
              this.$message.success(this.$t("pages.equipment.text68") + "!");
              setTimeout(() => {
                this.$emit("equipmentList");
                this.handleClose();
                this.loading = false;
              }, 500);
            });
        }
      });
    },
    //下载模版
    importTemplate() {
      this.request.importDevicetemplate().then();
    },
    //选择Excel上传
    equipmentImport(e) {
      this.from.url = e;
    },
  },
};
</script>

<style scoped>
.batchIdLenth {
  width: 192px;
}
</style>